import { Injectable } from '@angular/core';
import { PalletViewDataDisplayAuthService } from '../../../views/pallets/data-display/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class TanksViewDataDisplayAuthService extends PalletViewDataDisplayAuthService {
  override beingAbleToScan(): boolean {
    console.log('Being Able to Scan!');
    return this.lookForRolesNeeded([
      'Chief',
      'Admin',
      'TanksOperator',
      'TanksChief',
      'TankAdmin',
    ]);
  }
}
